// eslint-disable-next-line no-unused-vars
import React from 'react';
import { string } from 'prop-types';
import styled from '@emotion/styled';
import { Dropdown } from '@carbon/react';

const StyledDropdown = styled(Dropdown)`
  margin-bottom: 20px;
  background-color: transparent;

  &:hover {
    background-color: transparent;
  }

  
  .cds--list-box {
    border: 1px solid ${ props => props.theme.products.colors.border };
    border-radius: 5px;
    background-color: #fff;
  }

  .cds--list-box__menu {
    background-color: #fff;
  }
`;

const NWDropdown = ({ className, ...rest }) => (
  <StyledDropdown
    className={ `styledDropdown ${ className }` }
    { ...rest }
  />
);

NWDropdown.propTypes = {
  className: string,
};

export { NWDropdown };
